import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import { IEnabled} from './types';

const EnableContainer = (props: IEnabled) => {
  const { label, color, icon } = props;
  return (
    <div style={{ whiteSpace: 'nowrap'}}>
      <Box
        sx={{
          border: 1,
          borderColor: color,
          borderRadius: 16,
          color: color,
          display: 'inline-flex',
          paddingX: '10px',
          paddingY: '3px',
        }}
      >
        {icon}
        <Typography style ={{marginLeft: '5px'}}> {label} </Typography>
      </Box>
    </div>
  );
};

export default EnableContainer;